import { orderTrackingShipmentSummarySchema } from "@redotech/redo-model/order-tracking/order-tracking-shipment-definition";
import { AdvancedFilterDataSchema } from "@redotech/redo-model/views/views";
import * as z from "zod/v4";

export const exportOrderTrackingShipments = {
  name: "exportOrderTrackingShipments" as const,
  input: z.object({
    searchString: z.string().optional(),
    filters: z.array(AdvancedFilterDataSchema).optional(),
  }),
  output: z.object({ shipments: z.array(orderTrackingShipmentSummarySchema) }),
};
